import css from './index.module.scss';
import { useGlobal } from '@/utils/useGlobal';
import NextImage from '@/components/NextImage';
import { subscribe } from '@/service/vip';
import { checkAccountIsExist } from '@/service/login';
import { getPrivacyPolicy } from '@/utils/common';
import { subscribeCookie } from '@/utils/cookies/subscribeCookie';

export default function SignupPopupMain({ changeStatu, callback }: any) {
    const { useLang, useState, useRouter, isMobile, Link, gtm } = useGlobal();
    const { locale } = useRouter();
    const { t } = useLang('shared.signup_popup.main');
    const [input, setInput] = useState('');
    const [check, setCheck] = useState(['jp', 'au', 'us', 'ca'].includes(locale));
    const [showMsg, setShowMsg] = useState('');
    const emailRegex = /^[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\.[A-Za-z]{2,}$/;

    const handleInputChange = (v: any) => {
        setInput(v.target.value);
        if (!emailRegex.test(input)) {
            return setShowMsg('');
        }
    };

    const handleCheck = () => {
        setCheck(!check);
        if (!check && showMsg) {
            setShowMsg('');
        }
        if (check && !showMsg) {
            setShowMsg(t('check'));
        }
    };

    const handleSubmit = async () => {
        if (!input) {
            return setShowMsg(t('null') || t('tip'));
        }
        if (!emailRegex.test(input)) {
            return setShowMsg(t('tip'));
        }
        if (!check) {
            return setShowMsg(t('check'));
        }
        try {
            // 是否已注册 0 已注册 其他：没注册
            const res: any = await checkAccountIsExist({ email: input.trim() });
            callback(res.code === '0');
            if (res.code === '0') {
                setInput('');
                setShowMsg('');
                changeStatu(2);
            }
            try {
                const res = await subscribe(input.trim(), locale, 'WEB_POPUP_SUB', {
                    entry_name: `subscription floating`,
                });
                // 2058 重复订阅也继续下一步弹窗
                if (res?.code === '0' || res?.code === '2058') {
                    setInput('');
                    setShowMsg('');
                    changeStatu(2);
                    gtm.push({
                        event: 'uaEvent',
                        event_name: 'activity_submit',
                        button_name: t('btn'),
                        status: 'success',
                        tag: 'Agree',
                    });
                } else {
                    setShowMsg(res?.message);
                    console.error(res?.message);
                    gtm.push({
                        event: 'uaEvent',
                        event_name: 'activity_submit',
                        button_name: t('btn'),
                        status: 'fail',
                        tag: 'Agree',
                    });
                }
            } catch (e) {
                console.error(e);
                gtm.push({
                    event: 'uaEvent',
                    event_name: 'activity_submit',
                    button_name: t('btn'),
                    status: 'fail',
                    tag: 'Agree',
                });
            }
        } catch (err) {
            console.error(err);
            gtm.push({
                event: 'uaEvent',
                event_name: 'activity_submit',
                button_name: t('btn'),
                status: 'fail',
                tag: 'Agree',
            });
        }
    };

    return (
        <div className={`signup-popup-main ${css['signup-popup-main']} ${isMobile ? 'signup-popup-main-h5' : 'signup-popup-main-pc'}`}>
            <div className="popup-content">
                <span className="close" onClick={() => changeStatu(0)}>
                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <g opacity="0.4">
                            <path
                                fillRule="evenodd"
                                clipRule="evenodd"
                                d="M12 2.80005C14.5403 2.80005 16.8403 3.82993 18.5052 5.49486C20.1702 7.15979 21.2001 9.45978 21.2001 12C21.2001 14.5403 20.1702 16.8403 18.5052 18.5052C16.8403 20.1702 14.5403 21.2001 12 21.2001C9.45978 21.2001 7.15979 20.1702 5.49486 18.5052C3.82993 16.8403 2.80005 14.5403 2.80005 12C2.80005 9.45978 3.82993 7.15979 5.49486 5.49486C7.15979 3.82993 9.45978 2.80005 12 2.80005Z"
                                stroke="black"
                                strokeWidth="1.6"
                            />
                            <path d="M8.5 8.5L15.5 15.5M15.5 8.5L8.5 15.5" stroke="black" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round" />
                        </g>
                    </svg>
                </span>
                <p className="title">{t('title')}</p>
                <p className="desc">{t('desc')}</p>
                <div className="control">
                    <input type="text" className="input" value={input} onChange={handleInputChange} placeholder={t('placeholder')} />
                    <button className="subscribe" onClick={handleSubmit}>
                        {t('btn')}
                    </button>
                </div>
                {showMsg && <p className="error-msg">{showMsg}</p>}
                <div className="agreement">
                    <input type="checkbox" className="agree-check" id="agree" checked={check} onChange={handleCheck} />
                    <label htmlFor="agree" className="agree-label">
                        {t.rich('agree', {
                            a1: (text: string) => (
                                <Link className="link" href={getPrivacyPolicy(locale)}>
                                    {text}
                                </Link>
                            ),
                            a2: (text: string) => (
                                <Link
                                    className="link"
                                    href={`${
                                        locale === 'za'
                                            ? 'https://za.ecoflow.com/pages/terms-of-sale'
                                            : `https://${locale}.ecoflow.com/policies/terms-of-service`
                                    }`}
                                >
                                    {text}
                                </Link>
                            ),
                        })}
                    </label>
                </div>
                <div className="img-box">
                    <NextImage src={require(`@publicLocal/signup-popup/${isMobile ? 'h5' : 'pc'}/1.png`)} alt={t('title')} aria-label={t('title')} />
                </div>
            </div>
        </div>
    );
}
